<template>
  <section class="store-sales-category">
    <div class="head">
      <div v-for="item in 11" :key="item">{{ (item - 1) * 10 }}</div>
    </div>
    <div class="sliders">
      <div class="slider-box" v-for="(item, index) in typeOptions" :key="index">
        <div class="slider-line">
          <div>{{ item }}</div>
          <div class="num">{{ optionValues[index] }}<span>%</span></div>
        </div>
        <div class="slider">
          <el-slider
            v-model="optionValues[index]"
            :disabled="disabled"
            :show-tooltip="false"
            @change="handleChange"
          ></el-slider>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StoreSalesCategory",
  props: {
    value: {
      type: [String, Array],
      default: null,
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionValues: [],
    };
  },
  mounted() {
    if (this.value) {
      const arr = this.value.split("\n");
      arr.map((item, index) => {
        const itemArr = item.split("：")[1];
        const num = Number(itemArr.split("%")[0]);
        this.optionValues.push(num);
      });
    } else {
      this.typeOptions.map((item) => {
        this.optionValues.push(0);
      });
    }
  },
  methods: {
    handleChange(val) {
      const valueList = this.typeOptions.map((item, index) => {
        return `${item}：${this.optionValues[index]}%`;
      });
      const str = valueList.join("\n");
      this.$emit("input", str);
    },
  },
};
</script>

<style lang="less" scoped>
.store-sales-category {
  width: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    div {
      text-align: center;
      color: #666;
      padding-left: 10px;
      box-sizing: border-box;
    }
  }
  .sliders {
    .slider-box {
      .slider-line {
        color: #606266;
        display: flex;
        justify-content: space-between;
        :deep(.el-input__inner) {
          text-align: center;
        }
        .num {
          span {
            color: #999;
            margin-left: 2px;
          }
        }
      }
      .slider {
        padding: 0 10px;
        box-sizing: border-box;
        margin-top: -8px;
        :deep(.el-slider__button) {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}
</style>
